/* global $ */
'use strict';

function AgreementService(EVENTS, MODALS) {
	var PubSub = require('pubsub-js'),
		page = require('page');

	var agreementService = {
		init: function() {
			this.sevicesPath = 'http://agreementservice.test.svs.nike.com/rest/agreement/';

			this.classes = {
				loaderEnabled: 'loading-box--enabled'
			};
			this.selectors = {
				loader: '.loading-box',
				pageTermsOfUse: '#terms-of-use',
				pagePrivacyPolicy: '#privacy-policy'
			};

			this.$loadingBox = $(this.selectors.loader);

			this.seviceType = false;
			window.NIKE = window.NIKE || {};

			this.bindEvents();
		},

		bindEvents: function(){
			PubSub.subscribe(EVENTS.TERMS_OF_USE, function(msg, data){
				this.requestService(EVENTS.TERMS_OF_USE);
			}.bind(this));
			PubSub.subscribe(EVENTS.PRIVACY_POLICY, function(msg, data){
				this.requestService(EVENTS.PRIVACY_POLICY);
			}.bind(this));
		},

		requestService: function(type){
			this.seviceType = type;
			var data = {
				uxId: 'com.nike.unite',
				environment: 'test',
				agreementType: this.seviceType,
				country: window.NIKE.country.toUpperCase() || 'GB',
				language:  window.NIKE.lang || 'en',
				mobileStatus: true,
				requestType: 'redirect'
			};

			window.open(this.sevicesPath + '?' + $.param(data));

			// Uncomment if Ajax request will be needed
			//$.ajax({
			//	type: 'GET',
			//	url: this.sevicesPath,
			//	contentType : 'text/html',
			//	dataType: 'text/html',
			//	data: data,
			//	beforeSend: this.serviceBeforeSendHandler.bind(this),
			//	complete: this.serviceCompleteHandler.bind(this),
			//	success: this.serviceSuccessHandler.bind(this),
			//	error: this.serviceErrorHandler.bind(this)
			//});
		},

		serviceBeforeSendHandler: function(){
			this.$loadingBox.addClass(this.classes.loaderEnabled);
		},

		serviceCompleteHandler: function(){
			this.$loadingBox.removeClass(this.classes.loaderEnabled);
		},

		serviceSuccessHandler: function(data){
			$(this.selectors['#'+this.seviceType]).html(data);
			page(window.NIKE.urlId+'/'+this.seviceType);
		},

		serviceErrorHandler: function(){
			PubSub.publish(EVENTS.MODAL_OPEN, MODALS.ERROR_PROCESS);
		}
	};

	agreementService.init();
}

module.exports = AgreementService;
